
import Blog from '~/components/Common/Blog'
import Content from '~/components/Common/Blog/BlogContent/TextColorType'

export default {
    name: 'BlogTextColor',
    components: { Blog, Content },
    props: {
        newsType: String,
        pageTitle: String,
    },
}
